import { useState } from "react";
import convert from "image-file-resize";
import { toast } from "react-toastify";
import styled from "styled-components";
import { v4 as uuid } from "uuid";
import { storage } from "../firebase/utiles";
import {
  Form,
  Group,
  Label,
  Input,
  Masked,
  TextArea,
  Button,
  ButtonSecondary,
} from "../styles/form.elements";
import noimg from "../assets/no-image.png";

function FormularioPlato({
  formData,
  imagenUrl,
  setImagenUrl,
  onChange,
  onSubmit,
}) {
  const { nombre, descripcion, precio } = formData;

  const [imagen, setImagen] = useState(null);
  const [progreso, setProgreso] = useState(0);

  // funcion para cambiar el tamaño de la foto
  const handleImgConvert = (e) => {
    convert({
      file: e.target.files[0],
      width: 500,
      height: 500,
      type: "jpeg",
    })
      .then((resp) => {
        setImagen(resp);
        toast.info("Archivo de imagen en 500x500");
      })
      .catch((error) => {
        setImagen(null);
        toast.error("Hubo un error al tratar de convertir el archivo");
      });
  };

  // funcion para subir imagen al storage
  const imgUpload = () => {
    // eslint-disable-next-line
    const nombreImg = `${uuid()}-${imagen.name}`;
    const storageRef = storage.ref(`imagenes/${nombreImg}`);
    storageRef.put(imagen).on(
      "state_changed",
      (snap) => {
        let progreso = (snap.bytesTransferred / snap.totalBytes) * 100;
        setProgreso(progreso);
      },
      (err) => {
        toast.error("Hubo un error " + err);
      },
      async () => {
        const url = await storageRef.getDownloadURL();
        setImagenUrl(url);
      }
    );
  };

  return (
    <Form onSubmit={onSubmit}>
      <Group>
        <Label htmlFor="nombre">Nombre de plato</Label>
        <Input
          type="text"
          id="nombre"
          name="nombre"
          placeholder="Nombre del plato para el menú"
          value={nombre}
          onChange={onChange}
        />
      </Group>
      <Group>
        <Label htmlFor="descripcion">Descripción</Label>
        <TextArea
          name="descripcion"
          id="descripcion"
          placeholder="Descripción del plato"
          maxLength="150"
          value={descripcion}
          onChange={onChange}
        ></TextArea>
      </Group>
      <Group>
        <Label htmlFor="precio">Precio de plato</Label>
        <Masked
          mask="000.00"
          id="precio"
          name="precio"
          placeholder="100.00"
          value={precio}
          onChange={onChange}
        />
      </Group>
      <Group>
        <Img src={imagenUrl !== "" ? imagenUrl : noimg} alt="" />
        <Label htmlFor="imagenurl">Seleccione imagén</Label>
        <Input type="file" accept="image/jpeg" onChange={handleImgConvert} />
        <br />
        <ButtonSecondary type="button" onClick={imgUpload}>
          Subir
        </ButtonSecondary>
      </Group>
      <Progress max={100} value={progreso} />
      {progreso === 100 && (
        <Group>
          <Button type="submit">Guardar</Button>
        </Group>
      )}
    </Form>
  );
}

const Progress = styled.progress`
  width: 100%;
  height: 30px;
`;

const Img = styled.img`
  width: 80px;
  height: 80px;
`;

export default FormularioPlato;
